
import Vue from 'vue';
    import {Action, Getter} from 'vuex-class';
    import Component from 'vue-class-component';
    import {mdiMagnify, mdiPlus, mdiSortAscending, mdiSortDescending, mdiSortVariant, mdiDownload} from '@mdi/js';

    import {PageModel, SortModel, UsersElementsModel} from '@/models/admin';

    import UserSorter from '@/components/ReportSorter/AdminUserSorter.vue';
    import UserItem from '@/components/Service/User/UserItem.vue';
    import Paging from '@/components/Paging.vue';
    import UserDeletePopup from '@/components/UserDeletePopup.vue';
    import LoadMorePaginator from '@/components/Service/Base/LoadMorePaginator.vue';

    import {loadTableauLicenseCount} from '@/api/admin';

    const namespace = 'adminUser';
    const toggles = [
        {key: 'sorter', icon: mdiSortVariant},
        {key: 'search', icon: mdiMagnify},
    ];

    @Component({
        components: {
            LoadMorePaginator,
            UserSorter,
            UserItem,
            Paging,
            UserDeletePopup,
        },
        data() {
            return {
                toggles,
                mdiPlus,
                mdiMagnify,
                mdiDownload,
            };
        },
    })

    export default class UserList extends Vue {

        public get tableauLicenseCountText(): string {
          if (this.tableauLicenseCount === null) { return ''; }

          let licensesWord: string;
          let issuedWord: string;
          if (this.tableauLicenseCount % 100 >= 11 && this.tableauLicenseCount % 100 <= 19) {
            licensesWord = 'лицензий';
            issuedWord = 'выдано';
          } else {
            switch (this.tableauLicenseCount % 10) {
              case 1:
                licensesWord = 'лицензия';
                issuedWord = 'выдана';
                break;
              case 2:
              case 3:
              case 4:
                licensesWord = 'лицензии';
                issuedWord = 'выдано';
                break;
              default:
                licensesWord = 'лицензий';
                issuedWord = 'выдано';
                break;
            }
          }
          return 'На текущий момент ' + issuedWord + ' ' + this.tableauLicenseCount + ' ' + licensesWord + ' Tableau';
        }
        @Getter('users', {namespace}) public users!: UsersElementsModel[];
        @Getter('sorting', {namespace}) public sorting!: SortModel[];
        @Getter('paging', {namespace}) public paging!: PageModel;
        @Getter('totalCount', {namespace}) public totalCount!: number;

        @Action('load', {namespace}) public fetchData: any;
        @Action('changeContextFilter', {namespace}) public changeContextFilter: any;
        @Action('changeCompanyStatusFilter', {namespace}) public changeCompanyStatusFilter: any;
        @Action('changeSorting', {namespace}) public changeSorting: any;
        @Action('changePaging', {namespace}) public changePaging: any;
        public sorter: boolean = false;
        public search: boolean = false;
        public contextFilter: string = '';
        public companyStatusFilter: string = 'Активный';
        public items: any = ['Активный', 'Неактивный', 'Не выбран'];
        public tableauLicenseCount: number | null = null;
        @Action('dbExcelDump', {namespace}) private dbExcelDump: any;
        private userID: string = '';
        private showModalUserDelete: boolean = false;

        public mounted() {
            this.changeContextFilter('');
            this.changeCompanyStatusFilter('');
            this.changePaging({
                pageSize: 10,
                pageNumber: 1,
            });
            this.fetchData();
            this.loadTableauLicenseCount();
        }

        public loadTableauLicenseCount() {
            loadTableauLicenseCount().then((data) => {
                this.tableauLicenseCount = data;
            });
        }

        public onContextFilter(val: string) {
            this.changeContextFilter(val);
            this.fetchData();
        }

        public editUser(item: any) {
            this.$router.push({name: 'userTabs', params: {id: item.company.id}});
        }

        public toggle(key: string) {
            switch (key) {
                case 'sorter':
                    this.sorter = !this.sorter;
                    break;
                case 'search':
                    this.search = !this.search;
                    break;
            }
        }

        public getToggleClass(key: string) {
            let val = false;
            switch (key) {
                case 'sorter':
                    val = this.sorter;
                    break;
                case 'search':
                    val = this.search;
                    break;
            }

            return `d-sm-none round-btn ${val ? 'round-btn--active' : ''}`;
        }

        public handlerChangePaging(val: any) {
            this.changePaging(val);
            this.fetchData();
        }

        public onChangeCompanyStatusFilter(val: any) {
            switch (val) {
                case 'Активный':
                    this.companyStatusFilter = 'active';
                    break;
                case 'Неактивный':
                    this.companyStatusFilter = 'inactive';
                    break;
                default:
                    this.companyStatusFilter = '';
            }
            this.changePaging({
                pageSize: 10,
                pageNumber: 1,
            });
            this.changeCompanyStatusFilter(this.companyStatusFilter);
            this.fetchData();
        }

        public onRemove(id) {
            this.showModalUserDelete = true;
            this.userID = id;
        }

        public onCloseModalDelUser() {
            this.userID = '';
            this.showModalUserDelete = false;
        }

        public onDeleteUser() {
            this.$store.dispatch('commerce/deleteCompany', this.userID).then(() => {
                this.showModalUserDelete = false;
                this.userID = '';
                this.fetchData();
            });
        }
    }
